<div class="container-fluid py-4">
  <div class="row justify-content-md-center py-4 py-md-10">
    <div class="col-md-8">
      <h1 class="pb-sm-4" data-test-id="profile-page-hint">
        <svg-icon src="assets/icons/icon-profile.svg" class="icon-profile"> </svg-icon>
        {{ 'PROFILE_EDIT_DATA_HINT' | translate }}
      </h1>
      <div *ngIf="baseFormContent">
        <app-form-constructor-profile-base
          [formContent]="baseFormContent"
          (formComponentInitiated)="onFormComponentInitiated($event)"
        ></app-form-constructor-profile-base>
      </div>
      <ng-template user-type-form></ng-template>
      <div *ngIf="baseFormContent">
        <div class="py-2">
          <small class="form-text text-muted required-hint" data-test-id="small-required">
            * - {{ 'REQUIRED_FIELD_HINT' | translate }}
          </small>
        </div>

        <div>
          <button
            appLongOperation
            class="btn btn-primary"
            type="submit"
            data-test-id="btn-save-edit-profile"
            (click)="saveProfileInfo($event)"
          >
            {{ 'BTN_SAVE_HINT' | translate }}
          </button>
          <button
            type="button"
            class="btn btn-secondary pt-300 ms-3"
            data-test-id="btn-cancel-edit-profile"
            [routerLink]="LINK_PROFILE_VIEW"
          >
            {{ 'BTN_CANCEL_HINT' | translate }}
          </button>
        </div>

        <div class="pt-5">
          <a
            appLongOperation
            class="delete-profile-btn"
            data-test-id="change-password-profile-btn"
            [routerLink]="LINK_CHANGE_PASSWORD"
          >
            {{ 'CHANGE_PASSWORD_PROFILE_BTN_HINT' | translate }}
          </a>
        </div>
        <div class="pt-2">
          <a appLongOperation class="delete-profile-btn" data-test-id="delete-profile-btn" (click)="deleteProfile()">
            {{ 'DELETE_PROFILE_BTN_HINT' | translate }}
          </a>
        </div>
      </div>
      <div *ngIf="isLoading$ | async">
        <div class="spinner-grow text-primary m-5" role="status" data-test-id="edit-profile-loading-spinner">
          <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
        </div>
      </div>
      <small *ngIf="errorForm" class="form-text required-hint text-danger" data-test-id="error-form-small-required">
        {{ 'FORM_CONSTRUCTOR_ERROR_LEAST_ONE_REQUIRED_FIELD' | translate }}
      </small>
    </div>
  </div>
</div>
